<template>
  <div class="radio-buttons" :class="['d-grid', 'gap-3', {'is-invalid': showValidationError}]">
    <label v-if="label && showLabel" :for="inputName">
      <required v-if="required" />
      <span v-html="label" />
    </label>
    <div v-for="option in options" :key="option.value" class="d-flex align-items-top">
      <div class="me-2">
        <input :id="inputId(option)" v-model="value" type="radio" :name="inputName"
               :value="option.value" @change="emitNewValue" @focus="$emit('focus')">
      </div>
      <label :for="inputId(option)">
        <strong>
          {{ option.name }}
        </strong>
        <br>
        <div class="text-muted">
          {{ option.hint }}
        </div>
      </label>
    </div>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import radioButtonsInputMixin from './radio-buttons-input-mixin'

export default {
  mixins: [radioButtonsInputMixin],

  props: {
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['focus'],

  methods: {
    inputId(option) {
      return `${this.inputName}-${option.value}`
    }
  }
}
</script>
